let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gs4Hb")).then(() => parcelRequire('1pQ0C'));